// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"82dc73e0","41":"e79a51b5","67":"0cb26a44","126":"f81d8a05","127":"b1d0ef92","131":"9bbb0ead","230":"30ced779","354":"15e1ff3a","754":"e79a51b5","891":"8d50670b","895":"c58a65f6"}[chunkId] + ".chunk.css";
};